import { render, staticRenderFns } from "./LeaguesDatatable.vue?vue&type=template&id=bf6ea26a&"
import script from "./LeaguesDatatable.vue?vue&type=script&lang=js&"
export * from "./LeaguesDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports